import { Card } from '@toggle/design-system';
import { Earning } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EarningState } from '../types';
import { formatEarning, getEarningState } from '../utils';
import styles from './ExpectationReported.module.scss';

export interface ExpectationReportedProps {
  earning: Earning;
  currency: string;
}

export const ExpectationReported = ({
  earning,
  currency,
}: ExpectationReportedProps) => {
  const { t } = useTranslation('earnings');

  const valueFormatted = formatEarning(earning, currency);
  const earningState = getEarningState(earning);

  return (
    <div className={styles.expectationReportedRoot} data-testid="expectation-reported">
      {earningState === EarningState.Beat && (
        <Card className={styles.successCard} data-testid="expectation-reported-beat">
          {t('earnings:expectationReportedBeat', {
            value: valueFormatted,
          })}
        </Card>
      )}

      {earningState === EarningState.Miss && (
        <Card className={styles.criticalCard} data-testid="expectation-reported-miss">
          {t('earnings:expectationReportedMiss', {
            value: valueFormatted,
          })}
        </Card>
      )}

      {earningState === EarningState.Meet && (
        <Card data-testid="expectation-reported-meet">
          {t('earnings:expectationReportedMeet')}
        </Card>
      )}
    </div>
  );
};
